import React, { useState, useCallback } from 'react';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import { twMerge } from 'tailwind-merge';
import useMeetingKeyboardShortcuts from 'flow/hooks/useMeetingKeyboardShortcuts';
import { toggleMeetingJoinInfoActive } from 'flow/actions/meeting-actions';
import {
    selectActiveMeetingViewIsFullscreen,
    selectActiveMeetingIsNarrowWindow,
    selectIsUserLoggedIn,
} from 'flow/selectors/meeting-selectors';
import MeetingFooterButtons from './footer/MeetingFooterButtons';
import MeetingScreenSharePromptElectron from './MeetingScreenSharePromptElectron';

export const MeetingFooter = () => {
    const dispatch = useAppDispatch();
    const isFullscreenView = useAppSelector(
        selectActiveMeetingViewIsFullscreen,
    );
    const isNarrowWindow = useAppSelector(selectActiveMeetingIsNarrowWindow);
    const isUserLoggedIn = useAppSelector(selectIsUserLoggedIn);

    const [electronScreenShareMenuIsOpen, setElectronScreenShareMenuIsOpen] =
        useState(false);

    // Handle keyboard shortcuts for meeting controls
    useMeetingKeyboardShortcuts();

    const closeElectronScreenShareMenu = useCallback(
        () => setElectronScreenShareMenuIsOpen(false),
        [],
    );
    // Joining info is now a persistent side panel (like chat/participants)
    // rather than a blocking modal — see MeetingJoinInfoPanel.
    const openCloseJoinInfo = useCallback(() => {
        dispatch(toggleMeetingJoinInfoActive());
    }, [dispatch]);

    return (
        <div
            className={twMerge(
                // Always a full-width bar at the bottom, mirroring the header —
                // the content (video + side panels) is framed above it.
                'h-meeting-footer bottom-0 z-30 flex w-full items-center bg-black text-white',
                // The footer collapses its end group into the more-menu off its
                // own width (see meeting-footer-utils) in every form factor, so
                // the container is always present.
                '@container/meeting-footer',
                isFullscreenView || isNarrowWindow
                    ? 'fixed start-0'
                    : 'relative',
                !isUserLoggedIn ? '!fixed' : '',
            )}
        >
            {electronScreenShareMenuIsOpen ? (
                <MeetingScreenSharePromptElectron
                    closeScreenShareMenu={closeElectronScreenShareMenu}
                />
            ) : null}

            <MeetingFooterButtons
                openCloseJoinInfo={openCloseJoinInfo}
                setElectronScreenShareMenuIsOpen={
                    setElectronScreenShareMenuIsOpen
                }
            />
        </div>
    );
};

export default React.memo(MeetingFooter);
